import './Modal.css';
export default {
    "root": "Modal_root__120gn",
    "headerText": "Modal_headerText__120gn",
    "divider": "Modal_divider__120gn",
    "modalContent": "Modal_modalContent__120gn",
    "modalHeader": "Modal_modalHeader__120gn",
    "closeButton": "Modal_closeButton__120gn",
    "modalBody": "Modal_modalBody__120gn"
};
